module.exports = __webpack_public_path__ + "img/FI23319639.9b137e78.svg";